<div *ngIf="order" class="row">
  <app-shop-order-line *ngFor="let orderLine of orderLines" class="col-12" [orderLine]="orderLine"
    (removeLine)="onRemoveLine($event)"
    [canRemoveLine]="canRemoveLine"></app-shop-order-line>
  <div class="col-6 total-amount-title">
    {{ 'Total Amount' | translate }}:
  </div>
  <div class="col-6 total-amount">
    {{ toMoneyStr(totalAmount) }}
  </div>
  <div class="col-6 total-tax-title">
    {{ 'Tax' | translate }}:
  </div>
  <div class="col-6 total-tax">
    {{ toMoneyStr(totalTax) }}
  </div>
  <div class="col-6 total-net-title">
    {{ 'Net' | translate }}:
  </div>
  <div class="col-6 total-net">
    {{ toMoneyStr(totalAmount-totalTax) }}
  </div>
</div>
